import { CircularProgress } from "@mui/material";

export default function SettingUpOverlay() {
  return (
    <div className="ir-modal-layer" role="alertdialog" aria-busy="true" aria-live="polite">
      <div className="ir-modal ir-setup-modal">
        <CircularProgress sx={{ color: "#54FF99" }} />
        <h2>Setting up your account</h2>
        <p>This only takes a moment. Please don’t close this page.</p>
      </div>
    </div>
  );
}
